module.exports = __webpack_public_path__ + "assets/media/EXTENSION_PREVIEW_IMAGE.8ebbac26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/EXTENSION_PREVIEW_IMAGE.svg
// module id = 2005
// module chunks = 0